export function objectKeysToLowerCase(input: Object) {
    if(typeof input !== 'object') return input;
    if(Array.isArray(input)) return input.map(objectKeysToLowerCase);
    return Object.keys(input).reduce(function (newObj, key) {
        newObj[key.toLowerCase()] = input[key];
        return newObj;
    }, {});
}
